import React from 'react';
import { AlertTriangle } from 'lucide-react';

export default function CriticalOverrideBanner({ override }) {
    if (!override?.triggered) return null;

    return (
        <div className="rounded-lg border-l-4 border-red-600 bg-red-50 dark:bg-red-950/40 p-4 mb-4">
            <div className="flex items-start gap-3">
                <AlertTriangle className="text-red-600 dark:text-red-400 flex-shrink-0 mt-0.5" size={20} />
                <div className="flex-1">
                    <div className="font-semibold text-red-800 dark:text-red-200">Critical Override Triggered</div>
                    <div className="text-sm text-red-700 dark:text-red-300 mt-1">
                        JPRO Index forced to Critical — cannot average out of a life-safety or capital-adequacy failure.
                    </div>
                    <ul className="mt-2 text-sm text-red-700 dark:text-red-300 list-disc list-inside space-y-1">
                        {override.reasons?.map((r, i) => <li key={i}>{r}</li>)}
                    </ul>
                </div>
            </div>
        </div>
    );
}
